import { Reveal, Eyebrow } from "./Reveal";

export const SpazioPerTe = () => (
    <section id="spazio-per-te" className="bg-cream" data-testid="spazio-section">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20 md:py-32 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
            <Reveal className="order-2 lg:order-1">
                <div className="overflow-hidden rounded-3xl shadow-xl shadow-petrol/10 aspect-[4/3] bg-sand">
                    <img
                        src="/images/studio.jpg"
                        alt="Lo studio del Dott. Giovanni De Lorenzo: un ambiente accogliente con poltrone e luce naturale"
                        className="h-full w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
                        loading="lazy"
                    />
                </div>
            </Reveal>
            <div className="order-1 lg:order-2">
                <Reveal>
                    <Eyebrow>Un luogo in cui fermarsi e capire</Eyebrow>
                    <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl leading-snug text-ink" data-testid="spazio-title">
                        Prima di cambiare, bisogna comprendere.
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <div className="mt-7 space-y-4 text-base sm:text-lg text-[#526063] leading-relaxed">
                        <p>
                            Quando qualcosa ci fa stare male, la prima reazione è spesso cercare di eliminarlo. Fermare l'ansia. Controllare la paura. Non arrabbiarsi. Smettere di pensare. Cambiare un comportamento.
                        </p>
                        <p>
                            Ma quello che viviamo non nasce dal nulla. Dietro una reazione ci sono emozioni, esperienze, pensieri, sensazioni del corpo e modi di stare in relazione con gli altri.
                        </p>
                        <p className="text-ink font-medium">
                            Perché comprendere ciò che ci succede cambia il modo in cui possiamo affrontarlo.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.2}>
                    <blockquote className="mt-9 border-l-2 border-terracotta pl-6 font-serif italic text-xl sm:text-2xl text-petrol leading-relaxed">
                        "Non tutto ciò che facciamo è una scelta consapevole. Imparare a riconoscerlo è già un cambiamento."
                    </blockquote>
                </Reveal>
            </div>
        </div>
    </section>
);
